import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatesFilterValues } from "../types/state";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: StatesFilterValues = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const states = createSlice({
  name: "states",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = states.actions;

export const selectSearchValue = (state: { states: StatesFilterValues }) =>
  state?.states?.searchValue;
export const selectIsActive = (state: { states: StatesFilterValues }) =>
  state?.states?.isActive;
export default states.reducer;
